import style from './teaser-keyfigure.scss';
import $ from "jquery";
import {animatedDigits} from "./animated-digits";
import timing from "DesignSystem/motion/timing";

const script = () => {

  const cssPrefix = 'TeaserKeyfigure';
  const $targets = $('.' + cssPrefix);

  $targets.each(function () {
    const $target = $(this);

    if(!$target.data(`init-${cssPrefix}`)) {
      $target.data(`init-${cssPrefix}`, true);

      if($target.hasClass('has-animated-counter')) {
        animatedDigits($('.' + cssPrefix + '-data', $target), $target, timing.params['x-slow']);
      }
    }
  });
};

export {
  style,
  script,
};
